import React from "react";

import Paper from "@/components/paper/Paper";
import { useTranslation } from "react-i18next";
import '@/app/pages/companyProfile/dnbHoovers/dnbHoovers.scss';
import { DNBHooversAudienceBuilderURL, DNBHooversNowURL, DNBHooversURL } from "@/app/pages/companyProfile/constant";

const DnbHoovers = ({}): JSX.Element => {
    
    const { t } = useTranslation();
    return (
        <div className="company-profile-dnb-hoovers-container">
            <Paper title="">
                <>
                    <div className="row">
                        <div className="col-md-12 my-2">
                            <h3 className="heading-hoovers">{t("companyProfile.dnbHooversComponent.headingText")} <span className="blue-text-heading"> {t("companyProfile.dnbHooversComponent.thisCompany")} </span> {t("companyProfile.dnbHooversComponent.headingSecondText")}</h3>
                            <p className="sub-heading-hoovers">{t("companyProfile.dnbHooversComponent.subHeadingText")}</p>
                        </div>
                    </div>
                    <div className="row dnb-hoovers-container">
                        <div className="col-md-4">
                            <div className="dnb-hoovers-box">
                                <h3 className="heading-5 mb-42">{t("companyProfile.dnbHooversComponent.dnbHooversHeading")}</h3>
                                <p className="sub-title">{t("companyProfile.dnbHooversComponent.forSalesTeams")}</p>
                                <p className="tryFreeText">{t("companyProfile.dnbHooversComponent.tryItFree")}</p>
                                <p>{t("companyProfile.dnbHooversComponent.fasterRoutePara")}</p>
                                <p className="freeTrialBox"><a role="button" href={DNBHooversURL} className="button-primary-blue-trial">{t("companyProfile.dnbHooversComponent.getAFreeTrial")}</a></p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="dnb-hoovers-box">
                                <h3 className="heading-5">{t("companyProfile.dnbHooversComponent.dnbHooversHeading")} {t("companyProfile.dnbHooversComponent.audienceBuilder")}</h3>
                                <p className="sub-title">{t("companyProfile.dnbHooversComponent.forMarketingAndRevOpsTeams")}</p>
                                <p className="tryFreeText">{t("companyProfile.dnbHooversComponent.tryItFree")}</p>
                                <p>{t("companyProfile.dnbHooversComponent.understandTargetPara")}</p>
                                <p className="freeTrialBox"><a role="button" href={DNBHooversAudienceBuilderURL} className="button-primary-blue-trial">{t("companyProfile.dnbHooversComponent.getAFreeTrial")}</a></p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="dnb-hoovers-box">
                                <h3 className="heading-5">{t("companyProfile.dnbHooversComponent.dnbHooversHeading")} {t("companyProfile.dnbHooversComponent.now")}</h3>
                                <p className="sub-title">{t("companyProfile.dnbHooversComponent.forIndividualGrowthLeaders")}</p>
                                <p className="mt-3">{t("companyProfile.dnbHooversComponent.StartBuildingParaOneText")} <span className="bold-text"> {t("companyProfile.dnbHooversComponent.zeroDollarUpfront")}</span> {t("companyProfile.dnbHooversComponent.StartBuildingParaSecondText")}</p>
                                <p>{t("companyProfile.dnbHooversComponent.AccessRecordsPara")}</p>
                                <p className="freeTrialBox"><a role="button" href={DNBHooversNowURL} className="button-primary-blue-trial">{t("companyProfile.dnbHooversComponent.startToday")}</a></p>
                            </div>
                        </div>
                    </div>
                </>
            </Paper>
        </div>
    )
}

export default DnbHoovers;